module.exports = __webpack_public_path__ + "media/images/course/3-1d741b49e940aabe877f4a70c67eadfa.png";